import Translations from 'src/core/utils/Translations';
import type ApiRequestError from 'src/core/models/api/ApiRequestError';

const toErrorMessage = (error: ApiRequestError): string =>
	error.response?.data?.message ?? (error instanceof Error ? error.message : Translations.unknownErrorOccurred);

export default toErrorMessage;
